module.exports = __webpack_public_path__ + "img/finance_BJ_DS.8ea14ad0.png";